<template id="mba-nw-graph">
<div>
<div class="card mt-1">
                    <div class="card-header text-left">

                        MBA Network Graph
                    </div>
                    <div class="card-body">
                    <img src="/img/nw_graph_top_20_rules.png" width="800px" height="500px"/>
                    </div>
                    </div>

</div>
</template>

<script>
export default {
name: 'mba-nw-graph'
}
</script>

<style scoped>

</style>